export default function ContentFrame({ children }: { children: React.ReactNode }) {
    return (
        <div className="h-full flex flex-col bg-orsane-content-background border border-neutral-200 rounded-sm shadow-sm/6 relative overflow-hidden">
            {children}
        </div>
    );
}
